import { RouteNames } from 'constants/routeNames'

const REACT_APP_BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN as string

// needed for the header mode (REACT_APP_HEADER_MODE=true) instead of inner (react) routes
export const STATIC_ROUTES = [
  {
    key: 'ONBOARDING',
    path: `${REACT_APP_BASE_DOMAIN}/${RouteNames.ONBOARDING}`,
  },
  {
    key: 'MYATD_DASHBOARD',
    path: `${REACT_APP_BASE_DOMAIN}/${RouteNames.MYATD}/${RouteNames.DASHBOARD}`,
  },
  { key: 'home', path: REACT_APP_BASE_DOMAIN },
  {
    key: 'MYATD_ACTIVITYHISTORY_LEARNING',
    path: `${REACT_APP_BASE_DOMAIN}/${RouteNames.MYATD}/${RouteNames.ACTIVITY_HISTORY}/${RouteNames.LEARNING}`,
  },
  {
    key: 'MYATD_BENEFITS_CENTER',
    path: `${REACT_APP_BASE_DOMAIN}/${RouteNames.MYATD}/${RouteNames.BENEFITS_CENTER}`,
  },
  { key: 'search', path: `${REACT_APP_BASE_DOMAIN}/${RouteNames.SEARCH}` },
  {
    key: 'PROFILE_PERSONALINFORMATION',
    path: `${REACT_APP_BASE_DOMAIN}/${RouteNames.PROFILE}/${RouteNames.PERSONAL_INFORMATION}`,
  },
  {
    key: 'PROFILE_ORDERS',
    path: `${REACT_APP_BASE_DOMAIN}/${RouteNames.PROFILE}/${RouteNames.ORDERS}`,
  },
  {
    key: 'MYATD_ACTIVITYHISTORY_BOOKMARKS',
    path: `${REACT_APP_BASE_DOMAIN}/${RouteNames.MYATD}/${RouteNames.ACTIVITY_HISTORY}/${RouteNames.BOOKMARKS}`,
  },
]
